import React, { useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
//
// NEW

// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
//VIDEO
//img poster
import imgPosterOldMountainTop from "../../OldMountain/preview_lowRes_videoOldMountain.png";
//
import videoAnimaSimurgHead from "../../OldMountain/TheSimurghMountain_by_vodanova.mp4";
//
//
import videoAnimaSimurghDetail from "../../OldMountain/TheSimurghMountain-detail_by_vodanova.mp4";

// LG IMG
import imgHeaderSimurghLg from "../../OldMountain/oldMountain_long_black.jpg";
//

// drawings
import flowerDrawing from "../../OldMountain/bananafleur.jpg";
import simurghDrawing from "../../OldMountain/simurgh-grand.jpg";
import conspiration from "../../OldMountain/conspiration-a-la-reine_.jpg";
//
//
//
//
// zoom in related
import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale
//
//
const SimurghGrid = ({ setSelectedSimurgh }) => {
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //

  //
  //

  // Scroll to element
  //
  const myRef = useRef(null);
  //
  //

  const executeScroll = () =>
    myRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  // this.myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <>
      <section id="theSimurghMount">
        <div className="theSimurghMount___wrapper">
          {/* 
          
          
          
          */}
          <div className="theSimurghMount__header">
            {/* heading */}
            <div className="theSimurghMount____headerTitle">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                THE SIMURGH
              </h1>
              <h2>MOUNT</h2>
              <h3> Selected Works </h3>
              <p>2008 | 2021</p>
            </div>
          </div>
          {/* 
          
          
          
          */}
          <div className="theSimurghMountVideo">
            <div className="theSimurghMountVideo__wrapper">
              {/* VIDEO */}
              <div className="theSimurghMountVideo____container">
                <video
                  controls
                  poster={imgPosterOldMountainTop}
                  // ---
                  // autoPlay
                  loop
                  playsInline
                  // muted
                  className="video____box"
                  src={videoAnimaSimurgHead}
                  type="video/mp4"
                ></video>
              </div>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          <div className="theSimurghMount__descript__row">
            <div className="theSimurghMount__descript__row__wrapper">
              <div className="theSimurghMount__descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>
                {/* <h3>The Simurgh Mount </h3> */}
                <p>Software used: Blender and Photoshop</p>
                <p> handmade drawn texture </p>
              </div>
              <div className="theSimurghMount__descript__row_article">
                <motion.h1 data-aos="fade-up">
                  <br />
                  When I first began this project in 2008, it was with the idea
                  of using the completed work as video game assets.
                  <span>
                    I wasn’t exactly sure about my end-goal at that time, but I
                    did envision the artworks vaguely as an end level or a boss
                    fight
                  </span>{" "}
                  Although I was aware that I hadn’t reached the level of
                  expertise in my own art style, as well as a sufficient level
                  of knowledge in the area.
                </motion.h1>
              </div>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          <div id="theSimurghMount__LGimg3d">
            <div className="theSimurghMount__LGimg3d_Wrapper">
              <div className="theSimurghMount__LGimg3d_ContainerLg">
                <motion.div
                  className="img_box"
                  data-aos="fade-up-left"
                  data-aos-duration="1000"
                  whileHover={{ scale: 1.2 }}
                  onHoverStart={(e) => {}}
                  onHoverEnd={(e) => {}}
                >
                  <img src={imgHeaderSimurghLg} alt="" />
                </motion.div>{" "}
              </div>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          <div id="theSimurghMount__descript__col">
            <div className="theSimurghMount__descript__col_wrapper">
              <div className="theSimurghMount__descript__col_article">
                {/* h1 */}
                <motion.h1 data-aos="fade-up">
                  So, in 2016, I took the decision to transition from
                  illustration to 3D design, which I realized would help me
                  solidify my idea the way I had intended it.
                  <span className="link" onClick={executeScroll}>
                    In the images shown below,
                  </span>
                  you can find three drawings I used for reference to visualize
                  this work. They are just a sample of the collection I created
                  over the period of 10 years , but these were vital for the
                  designing process of this prototype.
                </motion.h1>

                <h2>Below :</h2>

                <p>Software used: Blender and Photoshop</p>
                <p> handmade drawn texture </p>
              </div>
              {/* ---------- */}
            </div>
          </div>
          {/* 
          
          
          
          */}
          <div className="theSimurghMountVideoDetail">
            <div className="theSimurghMountVideoDetail-wrapper">
              <div className="theSimurghMountVideoDetail-container">
                <video
                  controls
                  // poster={videoAnimaSimurgHeadImg}
                  // ---
                  // autoPlay
                  loop
                  playsInline
                  // muted
                  className="video-box"
                  src={videoAnimaSimurghDetail}
                  type="video/mp4"
                ></video>
              </div>
            </div>
          </div>

          {/* 




         */}

          <div className="theSimurghMount__headerDrawings">
            <div className="theSimurghMount__headerDrawings_container">
              <h1>Drawings</h1>
            </div>
          </div>

          {/* 




         */}

          {/* ------------- */}
          <div className="theSimurghMount_BottomDescription">
            <div className="theSimurghMount_BotoomDescription__wrapper">
              <div className="theSimurghMount_BotoomDescription_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  The Myth
                </h1>
                <h2>Of the simurgh</h2>
                <h3>Above: </h3>
                <p>
                  Handmade drawings |<br></br>Technic: pointillism, hatching,
                  blending.
                </p>
              </div>
              <div className="theSimurghMount_BottomDescription__row_article">
                <motion.h1 data-aos="fade-up">
                  <br />
                  The mythical bird Simurgh (whose name is a combination of two
                  persian words, “si” which means the number 30, and “murg”
                  which means bird) is a traditional and revered figured in
                  folklore and religions across the world.
                  <span>
                    {" "}
                    A Persian poem, written by the famous Sufi poet Farid ud-Din
                    Attar, depicts a great flock of thousands of birds who
                    believe themselves lost without a leader in the world. These
                    birds are meant to represent all the faults that keeps
                    humans from finding enlightenment.
                  </span>{" "}
                  At the behest of a hoopoe, they set out to find the Simurgh,
                  who is rumored to be the wisest of them all. The birds set out
                  on a difficult quest, though the trials of love, knowledge,
                  detachment, unity, wonderment, poverty and annihilation.{" "}
                </motion.h1>
              </div>
            </div>
          </div>

          {/*
 
 
 
 
 
 
         */}

          <div id="theSimurghMount_drawings" ref={myRef}>
            <div className="theSimurghMount_drawings__wrapper">
              <div className="theSimurghMount_drawings__containerImgLg">
                <div className="img_box">
                  <img src={conspiration} alt="" />
                </div>{" "}
              </div>
              {/* 2  flowerDrawing */}
              <div className="theSimurghMount_drawings__containerImgM">
                <div className="img_box">
                  <img src={flowerDrawing} alt="" />
                </div>{" "}
              </div>{" "}
            </div>
          </div>
          {/* 
          
          
          
          
          
          */}
          {/* Simurgh drawing*/}
          <div id="theSimurghMount_drawingLG">
            <div className="theSimurghMount_drawingLG__Wrapper">
              <div className="theSimurghMount_drawingLG__ContainerLg">
                <div className="img_box">
                  <img src={simurghDrawing} alt="" />
                </div>{" "}
              </div>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
          <div id="theSimurghMount__descript__col">
            <div className="theSimurghMount__descript__col_wrapper">
              <div className="theSimurghMount__descript__col_article">
                {/* h1 */}
                <motion.h1 data-aos="fade-up">
                  At the end of their adventure, only 30 birds remain, and they
                  reach the abode of the Simurgh, only to be greeted by a
                  singular bird. It gives them a paper, where to their shock,
                  every struggle they faced during their endeavor is listed. The
                  Simurgh appears, and the birds are astonished to see
                  themselves in it, and the Simurgh in themselves. It tells them
                  that what they came to find was a mirror
                  <span>
                    for what they are is what the Simurgh is to them, that they
                    are the shadow to the sun, and the sun to the shadow. Upon
                    realizing that, that each of them became their own Simurgh,
                    that there are no more paths to travel and no more guides to
                    follow,
                  </span>
                  the birds disappear within the body of the Simurgh and become
                  one with it.
                </motion.h1>

                <h2>Above :</h2>
                <p>
                  Materials: ink, ballpoint pen, <br></br> watercolor, acrylic,
                  pencil.
                </p>
              </div>
              {/* ---------- */}
            </div>
          </div>
          {/* 
          
          
          
          */}
          {/* 
          
         

          {/* ------------- */}
        </div>
      </section>
    </>
  );
};

export default SimurghGrid;
